import React from 'react';
import ReactDOM from 'react-dom/client';
import store from './app/store';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';

// Function to detect TV user agent
function isTVDevice() {
  const ua = navigator.userAgent.toLowerCase();

  return (
    ua.includes("ubuntu") ||
    ua.includes("smart-tv") ||
    ua.includes("smarttv") ||
    ua.includes("appletv") ||
    ua.includes("hbbtv") ||
    ua.includes("netcast") ||
    ua.includes("tizen") || // Samsung
    ua.includes("webos") || // LG
    ua.includes("android tv") ||
    ua.includes("googletv") ||
    ua.includes("aft") || // Amazon Fire TV
    (ua.includes("android") && ua.includes("tv")) ||
    (ua.includes("bravia") && ua.includes("android")) || // Sony Bravia
    (ua.includes("philips") && ua.includes("android")) ||
    (ua.includes("sharp") && ua.includes("android")) ||
    (ua.includes("panasonic") && ua.includes("android"))
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isTVDevice()) {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
} else {
  root.render(
    <div style={{
      height: '100vh',
      backgroundColor: '#000',
      color: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '24px'
    }}>
      Welcome to velapps.com
    </div>
  );
}
